// import React, { useRef } from "react";
// import CountUp from "react-countup";
// import { useInView } from "react-intersection-observer";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { useEffect } from "react";

// const StatsSection = () => {
//   useEffect(() => {
//     // Initialize AOS with once: true to prevent repeated animations
//     AOS.init({
//       duration: 800,
//       easing: "ease-in-out",
//       once: false, // Animation happens only once
//       offset: 100, // Trigger animation 100px before element comes into view
//       delay: 0,
//     });

//     // Cleanup function to refresh AOS on component unmount
//     return () => {
//       AOS.refresh();
//     };
//   }, []);
//   const stats = [
//     {
//       number: "150+",
//       label: "Happy Clients",
//       end: 150,
//       suffix: "+",
//     },
//     {
//       number: "100%",
//       label: "Approved Projects",
//       end: 100,
//       suffix: "%",
//     },
//     {
//       number: "10+",
//       label: "Years Of Experience",
//       end: 10,
//       suffix: "+",
//     },
//     {
//       number: "50+",
//       label: "Delivered Projects",
//       end: 50,
//       suffix: "+",
//     },
//   ];

//   // Use react-intersection-observer to detect when section is in view
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.3,
//   });

//   return (
//     <div
//       ref={ref}
//       className="relative bg-gray-900 py-16 px-4 sm:px-6 lg:px-8"
//       data-aos="zoom-in"
//     >
//       {/* Background Pattern */}
//       <div className="absolute inset-0 overflow-hidden">
//         <div className="absolute top-0 left-0 w-full h-full">
//           {/* Diagonal lines pattern */}
//           <svg
//             className="absolute inset-0 w-full h-full"
//             viewBox="0 0 100 100"
//             preserveAspectRatio="none"
//           >
//             <defs>
//               <pattern
//                 id="diagonal-lines"
//                 patternUnits="userSpaceOnUse"
//                 width="20"
//                 height="20"
//               >
//                 <path
//                   d="M0,20 L20,0"
//                   stroke="rgba(255,255,255,0.02)"
//                   strokeWidth="0.5"
//                 />
//                 <path
//                   d="M-5,5 L5,-5"
//                   stroke="rgba(255,255,255,0.02)"
//                   strokeWidth="0.5"
//                 />
//                 <path
//                   d="M15,25 L25,15"
//                   stroke="rgba(255,255,255,0.02)"
//                   strokeWidth="0.5"
//                 />
//               </pattern>
//             </defs>
//             <rect width="100%" height="100%" fill="url(#diagonal-lines)" />
//           </svg>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="relative max-w-7xl mx-auto">
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
//           {stats.map((stat, index) => (
//             <div key={index} className="text-center">
//               <div className="mb-3">
//                 <span className="text-4xl sm:text-5xl lg:text-6xl font-bold text-orange-500 leading-none">
//                   {inView ? (
//                     <CountUp
//                       end={stat.end}
//                       suffix={stat.suffix}
//                       duration={2}
//                       delay={0.1 * index} // Stagger the animations
//                     />
//                   ) : (
//                     `0${stat.suffix}`
//                   )}
//                 </span>
//               </div>
//               <div className="text-white text-sm sm:text-base lg:text-lg font-medium tracking-wide">
//                 {stat.label}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StatsSection;

import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import AOS from "aos";
import "aos/dist/aos.css";

const StatsSection = () => {
  const [countKey, setCountKey] = useState(0);

  // AOS initialization
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: false,
      offset: 100,
      delay: 0,
    });

    return () => {
      AOS.refresh();
    };
  }, []);

  const stats = [
    {
      label: "Happy Clients",
      end: 200,
      suffix: "+",
    },
    {
      label: "Approved Projects",
      end: 100,
      suffix: "%",
    },
    {
      label: "Years Of Experience",
      end: 10,
      suffix: "+",
    },
    {
      label: "Delivered Projects",
      end: 50,
      suffix: "+",
    },
  ];

  // Intersection observer
  const [ref, inView] = useInView({
    triggerOnce: false, // We want it to count every time it comes into view
    threshold: 0.3,
  });

  // When in view, restart CountUp
  useEffect(() => {
    if (inView) {
      setCountKey((prev) => prev + 1);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      className="relative bg-gray-900 py-16 px-4 sm:px-6 lg:px-8 "
      data-aos="zoom-in"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full">
          <svg
            className="absolute inset-0 w-full h-full"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <defs>
              <pattern
                id="diagonal-lines"
                patternUnits="userSpaceOnUse"
                width="20"
                height="20"
              >
                <path
                  d="M0,20 L20,0"
                  stroke="rgba(255,255,255,0.02)"
                  strokeWidth="0.5"
                />
                <path
                  d="M-5,5 L5,-5"
                  stroke="rgba(255,255,255,0.02)"
                  strokeWidth="0.5"
                />
                <path
                  d="M15,25 L25,15"
                  stroke="rgba(255,255,255,0.02)"
                  strokeWidth="0.5"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#diagonal-lines)" />
          </svg>
        </div>
      </div>

      {/* Stats Content */}
      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="mb-3">
                <span className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#FF5A3C] leading-none">
                  {inView ? (
                    <CountUp
                      key={countKey + index}
                      end={stat.end}
                      suffix={stat.suffix}
                      duration={2}
                      delay={0.1 * index}
                    />
                  ) : (
                    `0${stat.suffix}`
                  )}
                </span>
              </div>
              <div className="text-white text-sm sm:text-base lg:text-lg font-medium tracking-wide">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
